import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import MaskedLines from "./MaskedLines";
import { scrollToId } from "./Hero";
import { DEMOLARI_B } from "@/constants/images";

export default function FinalCTA() {
    return (
        <section className="relative px-5 py-14 lg:px-10 lg:py-20">
            <div className="relative mx-auto max-w-[1600px] overflow-hidden rounded-2xl border border-line">
                <img
                    src={DEMOLARI_B}
                    alt=""
                    aria-hidden="true"
                    className="absolute inset-0 h-full w-full object-cover opacity-20"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/80 to-ink/40" />

                <div className="relative z-10 px-6 py-12 sm:px-10 lg:px-16 lg:py-16">
                    <div className="flex items-center gap-4">
                        <span className="h-[2px] w-10 bg-flame" />
                        <span className="font-mono-tech text-[11px] tracking-[0.3em] text-mist">
                            CONTACT
                        </span>
                    </div>

                    <MaskedLines
                        inView
                        stagger={0.12}
                        className="mt-8 font-display font-extrabold uppercase leading-[0.98] tracking-[-0.01em]"
                        lineClassName="text-[clamp(1.9rem,4.2vw,4.2rem)]"
                        lines={[
                            <>AI O LUCRARE</>,
                            <>
                                PENTRU <span className="text-flame">NOI?</span>
                            </>,
                        ]}
                    />

                    <motion.p
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.5 }}
                        transition={{ duration: 0.9, delay: 0.35, ease: [0.16, 1, 0.3, 1] }}
                        className="mt-6 max-w-lg text-sm leading-relaxed text-mist lg:text-[15px]"
                    >
                        Spune-ne de ce ai nevoie și găsim soluția potrivită
                        pentru lucrarea ta.
                    </motion.p>

                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.5 }}
                        transition={{ duration: 0.9, delay: 0.45, ease: [0.16, 1, 0.3, 1] }}
                        className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center"
                    >
                        <Link
                            to="/contact"
                            data-testid="final-cta-contact"
                            className="group inline-flex w-fit items-center gap-3 bg-flame px-7 py-4 font-mono-tech text-xs font-bold tracking-[0.2em] text-white transition-all duration-300 hover:bg-flame-hover hover:shadow-[0_0_30px_rgba(255,85,0,0.35)]"
                        >
                            CONTACTEAZĂ-NE
                            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                        </Link>
                        <a
                            href="#servicii"
                            data-testid="final-cta-services"
                            onClick={(e) => {
                                e.preventDefault();
                                scrollToId("#servicii");
                            }}
                            className="group inline-flex w-fit items-center gap-3 border border-paper/25 px-7 py-4 font-mono-tech text-xs font-bold tracking-[0.2em] text-paper transition-all duration-300 hover:border-flame hover:text-flame"
                        >
                            VEZI SERVICIILE
                            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                        </a>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}